import dynamic from "next/dynamic";
import CenterWrapper from "Components/CenterWrapper";
import { FC, useContext } from "react";
import { Title, StyledP } from "./Jobs.styled";
import { PublicationContext } from "common/context/Publication";
import { publicationTypes } from "common/context/Publication/PublicationContext";

const Catagories = dynamic(() => import("./Catagories"));
const Editorial = dynamic(() => import("./Editorial"));
const JobsFilter = dynamic(() => import("./JobsFilter"));
const Actions = dynamic(() => import("./Actions"));
const Hiring = dynamic(() => import("./Hiring"));
const FeaturedJobs = dynamic(() => import("Components/FeaturedJobs"));

interface Props {
  feeds: any;
}

const Jobs: FC<Props> = ({ feeds }) => {
  const { config } = useContext<publicationTypes>(PublicationContext);

  return (
    <CenterWrapper>
      <Title>Looking for a new job?</Title>
      <StyledP>
        Looking for jobs in your area? As the official job site for {config.pub}
        , we have many local jobs for you to search and apply for.
      </StyledP>

      <StyledP>
        {" "}
        Whether you're searching for full-time employment or part-time and
        agency roles, you can find and apply for the latest vacancies across a
        range of industries and sectors.
      </StyledP>

      <StyledP>
        {" "}
        Take your first step towards finding the perfect new role for you by
        searching our vacancies today.
      </StyledP>
      <FeaturedJobs jobs={feeds} />
      <JobsFilter />
      <Catagories catagories={feeds.catagories} />
      <Actions />
      <Editorial editorialFeed={feeds.editorialFeed} />
      <Hiring />
    </CenterWrapper>
  );
};

export default Jobs;
